import React from 'react'; 
import './HeroSection.css';

function HeroSection() {
  return (
    <div className="hero">
      <div className="image-container">
        <img src="/main.jpg" alt="Main Image"/>
      </div>
      <h1 className="hero-title">Welcome to Alba Foam</h1>
      <p className="slogan">Where quality meets excellence.</p>
    </div>
  );
}

export default HeroSection;
